import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

import { withDefaults } from 'vue'
interface Props {
    menuData: Record<string, any>[],
    isZh:boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SubMenuItem',
  props: {
    menuData: { default: () => [] },
    isZh: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { menuData: Record<string, any>[], isZh:boolean };



return (_ctx: any,_cache: any) => {
  const _component_sub_menu_item = _resolveComponent("sub-menu-item", true)!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menuData, (item, index) => {
    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
      (item.menuType==='0')
        ? (_openBlock(), _createBlock(_component_el_sub_menu, {
            key: 0,
            index: item.id+''
          }, {
            title: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(__props.isZh?item.menuNameCn:item.menuNameEn), 1)
            ]),
            default: _withCtx(() => [
              (item.subMenuList.length)
                ? (_openBlock(), _createBlock(_component_sub_menu_item, {
                    key: 0,
                    menuData: item.subMenuList,
                    isZh: __props.isZh
                  }, null, 8, ["menuData", "isZh"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["index"]))
        : (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 1,
            index: item.id+''
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.isZh?item.menuNameCn:item.menuNameEn), 1)
            ]),
            _: 2
          }, 1032, ["index"]))
    ], 64))
  }), 128))
}
}

})